import React from 'react';
import { supabase } from '../lib/supabase';

export default function Topbar({ stats, onRefresh, session }) {
  const email = session?.user?.email || '';
  const initials = email ? email[0].toUpperCase() : 'RE';

  return (
    <header style={{
      gridColumn:'1/-1', display:'flex', alignItems:'center',
      background:'var(--surface)', borderBottom:'1px solid var(--border)', padding:'0 24px'
    }}>
      <div style={{
        fontFamily:'var(--serif)', fontSize:18, fontWeight:500,
        letterSpacing:'-0.02em', display:'flex', alignItems:'center', gap:10
      }}>
        <div style={{ width:8, height:8, borderRadius:'50%', background:'var(--accent)' }}/>
        Cerebro Risk
        <span style={{
          color:'var(--muted2)', fontWeight:300, fontStyle:'italic',
          fontSize:13, marginLeft:4
        }}>
          virtual risk engineering
        </span>
      </div>

      <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:20 }}>
        <Stat label="Active" value={stats.open} />
        <Stat label="SLA Breach" value={stats.sla} color="var(--red)" />
        <Stat label="Quoted Today" value={stats.quoted} color="var(--green)" />

        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{
            width:32, height:32, borderRadius:'50%', background:'var(--surface3)',
            border:'1px solid var(--border2)', display:'flex', alignItems:'center',
            justifyContent:'center', fontSize:11, color:'var(--muted2)',
          }}>
            {initials}
          </div>
          <div
            onClick={() => supabase.auth.signOut()}
            style={{ fontSize:11, color:'var(--muted)', cursor:'pointer' }}
          >
            Sign out
          </div>
        </div>
      </div>
    </header>
  );
}

function Stat({ label, value, color }) {
  return (
    <div>
      <div style={{
        fontSize:10, color:'var(--muted)',
        letterSpacing:'0.08em', textTransform:'uppercase'
      }}>
        {label}
      </div>
      <div style={{ fontSize:14, fontWeight:500, color: color || 'var(--text)' }}>
        {value ?? '—'}
      </div>
    </div>
  );
}